import React from 'react'
import type { SelectOption } from '@ztechapps/webui.input'
import { CheckboxInput, InlineDisplayContent, TextInput } from '@ztechapps/webui.input'
import { CountrySelect } from '@ztechapps/webui.location'
import { ShowIf } from '@ztechapps/webui.util'
import { Col, Row, Stack } from 'react-bootstrap'
import { useCheckoutContext } from '../../index'

export const BillToCustomer = (props: { mdSize?: number; disabled?: boolean }) => {
  const context = useCheckoutContext()

  const mdSize = props.mdSize ?? 4
  const disabled = props.disabled ?? false

  const fromStore = context.fromStore
  const [shippingOptions, setShippingOptions] = context.shippingOptions
  const billTo = shippingOptions.shippingBillTo
  const isManualShippingRate = shippingOptions.isManualShippingRate
  // const [, setCarrierRate] = useCarrierRate()
  // const groupedByCarrier = useGroupedCarrierRate()

  const isBillToCustomer = billTo?.isBillToCustomer && !isManualShippingRate

  return (
    <Stack gap={2}>
      <div>
        <CheckboxInput
          label={
            fromStore ? 'Use my UPS/FedEx account for shipping.' : "Use customer's UPS/FedEx account for shipping."
          }
          id="billToMe"
          checked={isBillToCustomer}
          onChange={(e) => {
            //set the carrier rate to null if isBillToCustomer is true
            let carrierRate = shippingOptions.carrierRate
            if (isBillToCustomer) {
              carrierRate = null
            }

            setShippingOptions({
              carrierRate,
              shippingBillTo: {
                isBillToCustomer: e,
              },
              isManualShippingRate: false,
            })
          }}
          disabled={disabled}
        />
      </div>

      <ShowIf condition={isBillToCustomer}>
        <Row className={' g-2'}>
          <Col md={mdSize}>
            <InlineDisplayContent label="UPS or FedEx Account #">
              <TextInput
                disabled={disabled}
                placeholder="Account (e.g. 658E93)"
                value={billTo?.account}
                onChange={(e) => {
                  setShippingOptions({
                    shippingBillTo: {
                      account: e?.target?.value?.toUpperCase?.(),
                    },
                  })
                }}
              />
            </InlineDisplayContent>
          </Col>
          <Col md={mdSize}>
            <InlineDisplayContent label="Postal Code">
              <TextInput
                disabled={disabled}
                placeholder="Postal code (e.g. 94043)"
                value={billTo?.postalCode}
                onChange={(e) => {
                  setShippingOptions({
                    shippingBillTo: {
                      postalCode: e?.target?.value?.toUpperCase?.(),
                    },
                  })
                }}
              />
            </InlineDisplayContent>
          </Col>
          <Col md={mdSize}>
            <InlineDisplayContent label="Country Code">
              <CountrySelect
                isDisabled={disabled}
                {...{
                  placeholder: 'Your country code (e.g. US)',
                  value: { value: billTo?.countryCode, label: billTo?.countryCode },
                  onChange: (e: SelectOption) => {
                    setShippingOptions({
                      shippingBillTo: {
                        countryCode: e?.iso2,
                      },
                    })
                  },
                }}
              />
            </InlineDisplayContent>
          </Col>
        </Row>
      </ShowIf>
    </Stack>
  )
}
